<div class="admin-budget-notifications" id="admin-budget-notifications">
    <cv-admin-budget-title-header [title]="sectionTitle" [btnTemplate]="exportBtn"></cv-admin-budget-title-header>
    
    <ng-template #exportBtn>
        <div>
            <sol-button id="export-btn" variant="basic" size="medium" [matMenuTriggerFor]="menu.menu" [disabled]="budget.budgetList.length === 0">
                <span cvLocalizedText langSection="Budget_Setup" langKey="Export">Export</span>
            </sol-button>
            <sol-floating-menu #menu menuClass="export-menu-budget" [menuItems]="defaultMenuOptions" 
                    spriteIconPath="../App_Themes/CXone/icons/export-menu-icons.svg" position="'bottom'"></sol-floating-menu>
        </div>
    </ng-template>

    <div class="row">
        <div class="col-12 d-flex align-items-center budget-notifications-subsection">
            <span class="text-secondary fw-bold fs-5" cvLocalizedText langSection="Budget_Notifications" langKey="Enable_Notifications">Enable Notifications</span>
            <sol-slide-toggle 
                size="small"  
                [(ngModel)]="areNotificationsActive"
                [disabled]="!hasPermission('CREATE') && !hasPermission('WRITE')"
                (ngModelChange)="hasPermission('CREATE') || hasPermission('WRITE') ? changeAllNotificationStatus() : ''"
                class="ml-2">
            </sol-slide-toggle>
            <ng-container *ngIf="areNotificationsActive; else offState">
                <span class="ms-2" cvLocalizedText langSection="Budget_Notifications" langKey="On">On</span>
            </ng-container>
            <ng-template #offState>
                <span class="ms-2" cvLocalizedText langSection="Budget_Notifications" langKey="Off">Off</span>
            </ng-template>
        </div>
    </div>

    <div *ngIf="areNotificationsActive">
        <div class="row budget-notifications-checkbox-section">
            <div class="col-12 d-flex">
                <span class="text-danger me-1">*</span>
                <span class="text-secondary" cvLocalizedText langSection="Budget_Notifications" langKey="Get_Notified_Reach">Get notified when reach</span>
                <div class="ml-2">
                    <sol-checkbox 
                        *ngFor="let alert of alertValues"
                        [(ngModel)]="alert.selected"
                        [disabled]="!hasPermission('CREATE') && !hasPermission('WRITE')"
                        (ngModelChange)="hasPermission('CREATE') || hasPermission('WRITE') ? setAlertAtPercentage() : ''"
                        class="mr-2">
                        {{ alert.name }}
                    </sol-checkbox>
                </div>
            </div>
        </div>

        <div class="notification-agents-component position-relative">
            <div *ngFor="let budgetGroup of budget.budgetList" 
                 class="budget-group-item">
                <div class="row py-2">
                    <div class="col-6 d-flex align-items-center">
                        {{ budgetGroup.GroupLevelName }}
                    </div>
                    <div class="col-5 d-flex align-items-center justify-content-end">
                        <button class="btn btn-link p-0 me-3"
                            [disabled]="!hasPermission('CREATE') && !hasPermission('WRITE')"
                            (click)="hasPermission('CREATE') || hasPermission('WRITE') ? openNotificationAssignTool(budgetGroup) : ''">
                            <svg class="icon-16 fill-valyrianSteel">
                                <use href="../App_Themes/CxOne/icons/icon-edit.svg#icon-edit"></use>
                            </svg>
                        </button>
                        <sol-slide-toggle 
                        size="small"
                        [(ngModel)]="budgetGroup.isActive"
                        [disabled]="!hasPermission('CREATE') && !hasPermission('WRITE')"
                        (ngModelChange)="hasPermission('CREATE') || hasPermission('WRITE') ? changeNotificationStatus(budgetGroup) : ''">
                        </sol-slide-toggle>
                    </div>
                </div>

                <div class="row">
                    <div class="offset-1 col-10">
                        <div class="row align-items-center">
                            <div class="col-4 d-flex align-items-center py-2"
                                 *ngFor="let login of budgetGroup.NotifyLogins">
                                <img class="mr-3" 
                                     style="height: 25px; border-radius: 50%;"
                                     [alt]="login.LoginName" />
                                <span>{{ login.LoginName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>